export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => resolve(img);
    img.onerror = reject;
    img.onabort = reject;

    img.setAttribute('crossorigin', 'anonymous');
    img.src = src;
  });
}

export function downloadCanvas(canvasDOM: HTMLCanvasElement) {
  const link = document.createElement('a');
  const image = canvasDOM
    .toDataURL('image/png')
    .replace('image/png', 'image/octet-stream');
  link.download = 'filename.png';
  link.setAttribute('href', image);
  link.click();
}

export function fittingString(ctx:CanvasRenderingContext2D, str:string, maxWidth: number) {
  let { width } = ctx.measureText(str);
  const ellipsis = '…';
  const ellipsisWidth = ctx.measureText(ellipsis).width;
  if (width <= maxWidth || width <= ellipsisWidth) {
    return str;
  }
  let len = str.length;
  let result = str;
  while (width >= maxWidth - ellipsisWidth && len > 0) {
    result = result.substring(0, len);
    const { width: w } = ctx.measureText(result);
    width = w;
    len -= 1;
  }
  return result + ellipsis;
}
